export const todaySchedule = [
  {
    id: "MV-2041",
    customer: "Margaret Sullivan",
    moveType: "Residential — 3 BR House",
    from: "412 Maple Ridge Dr, Austin, TX",
    to: "88 Willow Crest Ln, Round Rock, TX",
    startTime: "07:30",
    duration: "6h",
    truck: "26ft Box Truck",
    crew: [
      { name: "Marcus Reed", avatar: "MR", color: "bg-ink-900" },
      { name: "Diego Alvarez", avatar: "DA", color: "bg-ink-700" },
      { name: "Tyler Brooks", avatar: "TB", color: "bg-ink-500" },
    ],
    status: "in-progress",
  },
  {
    id: "MV-2042",
    customer: "Jonathan Park",
    moveType: "Office Relocation",
    from: "1500 Congress Ave Ste 400, Austin, TX",
    to: "2200 Tech Ridge Blvd, Austin, TX",
    startTime: "09:00",
    duration: "8h",
    truck: "26ft Box Truck",
    crew: [
      { name: "Aaron Mills", avatar: "AM", color: "bg-ink-900" },
      { name: "Samira Khan", avatar: "SK", color: "bg-ink-700" },
      { name: "Caleb Thompson", avatar: "CT", color: "bg-ink-500" },
      { name: "Jordan Pierce", avatar: "JP", color: "bg-ink-600" },
    ],
    status: "in-progress",
  },
  {
    id: "MV-2043",
    customer: "Priya Iyer",
    moveType: "Apartment — Studio",
    from: "705 W 7th St #214, Austin, TX",
    to: "920 E Riverside Dr #1102, Austin, TX",
    startTime: "11:30",
    duration: "3h",
    truck: "16ft Cargo Van",
    crew: [
      { name: "Wes Holloway", avatar: "WH", color: "bg-ink-700" },
      { name: "Nina Castro", avatar: "NC", color: "bg-ink-500" },
    ],
    status: "scheduled",
  },
  {
    id: "MV-2044",
    customer: "Travis & Hannah Bell",
    moveType: "Residential — 2 BR Townhouse",
    from: "55 Greenbelt Way, Cedar Park, TX",
    to: "1410 Bluebonnet Hills, Leander, TX",
    startTime: "13:00",
    duration: "5h",
    truck: "20ft Box Truck",
    crew: [
      { name: "Owen Patel", avatar: "OP", color: "bg-ink-900" },
      { name: "Damon Frye", avatar: "DF", color: "bg-ink-700" },
      { name: "Ronnie Vega", avatar: "RV", color: "bg-ink-500" },
    ],
    status: "scheduled",
  },
  {
    id: "MV-2045",
    customer: "Eleanor Whitfield",
    moveType: "Long Distance — 4 BR House",
    from: "1108 Oak Hollow Pl, Georgetown, TX",
    to: "47 Pinecrest Ave, San Antonio, TX",
    startTime: "15:30",
    duration: "10h",
    truck: "26ft + Trailer",
    crew: [
      { name: "Kenji Yamada", avatar: "KY", color: "bg-ink-900" },
      { name: "Hector Solano", avatar: "HS", color: "bg-ink-700" },
      { name: "Briggs Cole", avatar: "BC", color: "bg-ink-600" },
      { name: "Levi Brooks", avatar: "LB", color: "bg-ink-500" },
    ],
    status: "scheduled",
  },
];

export const recentActivity = [
  {
    id: 1,
    icon: "ri-checkbox-circle-line",
    iconColor: "text-ink-700",
    iconBg: "bg-cream-100",
    title: "Move MV-2039 completed",
    detail: "Carla Mendez — 2 BR apartment to South Lamar",
    time: "12 min ago",
  },
  {
    id: 2,
    icon: "ri-bank-card-line",
    iconColor: "text-ink-700",
    iconBg: "bg-cream-100",
    title: "Deposit received — $480.00",
    detail: "From Jonathan Park for MV-2042",
    time: "38 min ago",
  },
  {
    id: 3,
    icon: "ri-user-add-line",
    iconColor: "text-ink-700",
    iconBg: "bg-cream-100",
    title: "New booking request",
    detail: "Hannah Wallace — Sat Jun 14, 4BR house move",
    time: "1 hr ago",
  },
  {
    id: 4,
    icon: "ri-time-line",
    iconColor: "text-ink-700",
    iconBg: "bg-cream-100",
    title: "Crew clocked in",
    detail: "Diego Alvarez started shift on MV-2041",
    time: "2 hr ago",
  },
  {
    id: 5,
    icon: "ri-star-line",
    iconColor: "text-ink-700",
    iconBg: "bg-cream-100",
    title: "New 5-star review",
    detail: "\u201cThe crew was respectful and fast.\u201d \u2014 R. Patel",
    time: "3 hr ago",
  },
  {
    id: 6,
    icon: "ri-alert-line",
    iconColor: "text-ink-700",
    iconBg: "bg-cream-100",
    title: "Reschedule requested",
    detail: "MV-2052 wants to move from Jun 10 → Jun 12",
    time: "4 hr ago",
  },
];

export const crewOnDuty = [
  {
    name: "Marcus Reed",
    role: "Lead Mover",
    project: "MV-2041",
    clockedIn: "07:24",
    hours: "4h 12m",
    status: "active",
    avatar: "MR",
    color: "bg-ink-900",
  },
  {
    name: "Diego Alvarez",
    role: "Mover",
    project: "MV-2041",
    clockedIn: "07:28",
    hours: "4h 08m",
    status: "active",
    avatar: "DA",
    color: "bg-ink-700",
  },
  {
    name: "Samira Khan",
    role: "Lead Mover",
    project: "MV-2042",
    clockedIn: "08:55",
    hours: "2h 41m",
    status: "active",
    avatar: "SK",
    color: "bg-ink-900",
  },
  {
    name: "Aaron Mills",
    role: "Mover",
    project: "MV-2042",
    clockedIn: "08:58",
    hours: "2h 38m",
    status: "active",
    avatar: "AM",
    color: "bg-ink-700",
  },
  {
    name: "Nina Castro",
    role: "Mover",
    project: "MV-2043",
    clockedIn: "—",
    hours: "—",
    status: "starting-soon",
    avatar: "NC",
    color: "bg-ink-500",
  },
  {
    name: "Owen Patel",
    role: "Driver",
    project: "MV-2044",
    clockedIn: "—",
    hours: "—",
    status: "starting-soon",
    avatar: "OP",
    color: "bg-ink-500",
  },
];

export const upcomingBookings = [
  {
    id: "BK-7821",
    customer: "Hannah Wallace",
    moveDate: "Sat, Jun 14",
    type: "4 BR House",
    quote: "$2,840",
    deposit: "paid",
  },
  {
    id: "BK-7822",
    customer: "Marcus Tribble",
    moveDate: "Sun, Jun 15",
    type: "Studio Apartment",
    quote: "$640",
    deposit: "pending",
  },
  {
    id: "BK-7823",
    customer: "The Okonkwo Family",
    moveDate: "Mon, Jun 16",
    type: "3 BR House + Storage",
    quote: "$3,420",
    deposit: "paid",
  },
  {
    id: "BK-7824",
    customer: "Lila Bergstrom",
    moveDate: "Tue, Jun 17",
    type: "2 BR Apartment",
    quote: "$1,180",
    deposit: "paid",
  },
];